import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./reducers/auth";
import { sessionReducer } from "./reducers/sessionSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    session: sessionReducer,
  },

});
export default store;
